/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ listingName: NonNullable<unknown> }} Listingisnowliveandvisibletousers7Inputs */

const en_listingisnowliveandvisibletousers7 = /** @type {(inputs: Listingisnowliveandvisibletousers7Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.listingName}" is now live and visible to users.`)
};

const de_listingisnowliveandvisibletousers7 = /** @type {(inputs: Listingisnowliveandvisibletousers7Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.listingName}“ ist jetzt online und für alle sichtbar.`)
};

/**
* | output |
* | --- |
* | "\"{listingName}\" is now live and visible to users." |
*
* @param {Listingisnowliveandvisibletousers7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingisnowliveandvisibletousers7 = /** @type {((inputs: Listingisnowliveandvisibletousers7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingisnowliveandvisibletousers7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingisnowliveandvisibletousers7(inputs)
	return de_listingisnowliveandvisibletousers7(inputs)
});
export { listingisnowliveandvisibletousers7 as "listingIsNowLiveAndVisibleToUsers" }